import localStorageRepositories from "@/plugins/localStorageRepositories";
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";

export const cvProcess = (cvCampaigns) => {
  const cvCampaignIds = cvCampaigns.map(c => String(c.id));

  // 共通ロジック関数
  const processSimpleClicks = (type, keyName, eventName) => {
    const logs = localStorageRepositories.get(keyName).getAllValid();
    const matchedKeys = Object.keys(logs).filter(id => cvCampaignIds.includes(id));
    matchedKeys.forEach(id => {
      localStorageRepositories.get(keyName).remove(id);
      trackStoreeelEvent(eventName, { [`${type}_id`]: id });
    });
  };

  const processComplexClicks = (keyName, eventName, keyFieldName) => {
    const logs = localStorageRepositories.get(keyName).getAllValid();
    const matchedKeys = Object.entries(logs).reduce((acc, [outerId, innerMap]) => {
      const hasMatch = Object.keys(innerMap).some(id => cvCampaignIds.includes(id));
      if (hasMatch) acc.push(outerId);
      return acc;
    }, []);
    matchedKeys.forEach(id => {
      localStorageRepositories.get(keyName).remove(id);
      trackStoreeelEvent(eventName, { [keyFieldName]: id });
    });
  };

  const processMediaLogs = (keyName, eventName) => {
    const logs = localStorageRepositories.get(keyName).getAllValid();
    const matchedKeys = Object.entries(logs).filter(([, value]) =>
      cvCampaignIds.includes(String(value.campaignId))
    ).map(([key]) => key);

    const mediaIds = [...new Set(matchedKeys.map(key => key.split("__")[0]))];
    const campaignIds = [...new Set(matchedKeys.map(key => key.split("__")[1]))];

    campaignIds.forEach(campaignId => {
      localStorageRepositories.get(keyName).removeByCampaignId(campaignId);
    });

    mediaIds.forEach(mediaId => {
      trackStoreeelEvent(eventName, { media_id: mediaId });
    });
  };

  // 各種ログ処理呼び出し
  processSimpleClicks("campaign", "campaignClick", "storeeel_campaign_click_cv");
  processComplexClicks("groupClick", "storeeel_group_click_cv", "group_id");
  processMediaLogs("mediaView", "storeeel_media_view_cv");
  processMediaLogs("ctaClick", "storeeel_media_click_cv");
};
